import { ConfiguratorContext, IConfiguratorInfo } from "helpers/context/Configurator/ConfiguratorContext";
import React from "react";

export default function useConfiguratorInfo():IConfiguratorInfo {
    return React.useContext(ConfiguratorContext);
}